function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9256 1.66744C16.7024 1.44419 16.3396 1.44419 16.1163 1.66744L9.00004 8.79767L1.86981 1.66744C1.64655 1.44419 1.28376 1.44419 1.06051 1.66744C0.837252 1.8907 0.837252 2.25349 1.06051 2.47674L8.58144 9.99767C8.69307 10.1093 8.8326 10.1651 8.98609 10.1651C9.12562 10.1651 9.27911 10.1093 9.39074 9.99767L16.9117 2.47674C17.1489 2.25349 17.1489 1.8907 16.9256 1.66744Z",
  fill: "#B01BAE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9256 7.66744C16.7024 7.44419 16.3396 7.44419 16.1163 7.66744L9.00004 14.7977L1.86981 7.66744C1.64655 7.44419 1.28376 7.44419 1.06051 7.66744C0.837252 7.8907 0.837252 8.25349 1.06051 8.47674L8.58144 15.9977C8.69307 16.1093 8.8326 16.1651 8.98609 16.1651C9.12562 16.1651 9.27911 16.1093 9.39074 15.9977L16.9117 8.47674C17.1489 8.25349 17.1489 7.8907 16.9256 7.66744Z",
  fill: "#B01BAE"
});

function SvgMoveDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDown);
export default __webpack_public_path__ + "static/media/move-down.2a983054.svg";
export { ForwardRef as ReactComponent };